import React from 'react'
import PropTypes from 'prop-types'

const NoIntegration = ({ size = 8 }) => {
  const sizeInRem = `${size}rem`

  return (
    <svg
      width={sizeInRem}
      height={sizeInRem}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Background circle */}
      <circle cx="60" cy="60" r="55" fill="#f8f9fa" stroke="#dee2e6" strokeWidth="2" />

      {/* Left connector (plug) */}
      <g>
        {/* Plug body */}
        <rect x="20" y="45" width="30" height="30" rx="4" fill="#6c757d" />
        {/* Plug prongs */}
        <rect x="50" y="52" width="8" height="6" rx="1" fill="#495057" />
        <rect x="50" y="62" width="8" height="6" rx="1" fill="#495057" />
        {/* Cable */}
        <rect x="10" y="55" width="12" height="10" rx="2" fill="#adb5bd" />
      </g>

      {/* Right connector (socket) */}
      <g>
        {/* Socket body */}
        <rect x="70" y="45" width="30" height="30" rx="4" fill="#6c757d" />
        {/* Socket holes */}
        <rect x="62" y="52" width="10" height="6" rx="1" fill="#495057" />
        <rect x="62" y="62" width="10" height="6" rx="1" fill="#495057" />
        {/* Wall plate */}
        <rect x="98" y="50" width="12" height="20" rx="2" fill="#adb5bd" />
      </g>

      {/* Disconnection gap - lightning bolt / break indicator */}
      <g>
        <path
          d="M58 50 L62 58 L58 58 L62 70"
          stroke="#dc3545"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </g>

      {/* X mark overlay */}
      <g opacity="0.9">
        <circle cx="90" cy="85" r="15" fill="#dc3545" />
        <path
          d="M84 79 L96 91 M96 79 L84 91"
          stroke="white"
          strokeWidth="3"
          strokeLinecap="round"
        />
      </g>
    </svg>
  )
}

NoIntegration.propTypes = {
  size: PropTypes.number
}

export default NoIntegration
